@if (visible()) {
  <div
    class="earnings-calendar"
    role="button"
    tabindex="0"
    (click)="onNavigate()"
    (keyup.enter)="onNavigate()"
    (keydown.space)="$event.preventDefault(); onNavigate()"
  >
    <span class="date">{{ nextEarningsDate }}</span>
    <span class="subline">Nächster Earnings-Termin</span>
  </div>
}
